import React from 'react'

import s from '../NotFound.module.scss'

const Umbrella = () => {
	return (
		<g
			id={s.umbrella}
			data-name='Layer 3'
		>
			<g>
				<circle
					className={s.cls4}
					cx='1187.53'
					cy='240.3'
					r='7.66'
					transform='translate(236.36 990.8) rotate(-49.71)'
				/>
				<g>
					<path
						className={s.cls5}
						d='M1219.56,359.67l55,100.52c32.7-48.48-6.87-142.43-91.75-214.38-84.41-71.55-183-95.33-225.81-56l114.21,44.14Z'
					/>
					<path
						className={s.cls6}
						d='M1182.79,245.81c-84.41-71.55-183-95.33-225.81-56l114.21,44.14Z'
					/>
					<polygon
						className={s.cls7}
						points='1182.79 245.81 1071.19 233.91 1219.56 359.67 1182.79 245.81'
					/>
				</g>
				<polygon
					className={s.cls8}
					points='1180.91 409.02 1274.54 460.19 1219.56 359.67 1071.19 233.91 956.98 189.76 1021.95 274.29 1180.91 409.02'
				/>
				<g>
					<rect
						className={s.cls4}
						x='997.45'
						y='358.35'
						width='175.58'
						height='5.1'
						transform='translate(108.21 955.38) rotate(-49.71)'
					/>
					<rect
						className={s.cls4}
						x='1028.09'
						y='399.36'
						width='21.46'
						height='32.27'
						rx='10.73'
						ry='10.73'
						transform='translate(515.04 -573.16) rotate(40.29)'
					/>
				</g>
			</g>
		</g>
	)
}

export default Umbrella
